export default "__VITE_ASSET__D_qpxmbD__"